(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["image-size-calculator"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-image-size-calculator]').forEach((calculator) => {
    if (calculator.dataset.initialized === 'true') return;
    calculator.dataset.initialized = 'true';

    const widthInput = calculator.querySelector('[data-calculator-width]');
    const heightInput = calculator.querySelector('[data-calculator-height]');
    const widthResult = calculator.querySelector('[data-calculator-width-result]');
    const heightResult = calculator.querySelector('[data-calculator-height-result]');
    const shapeResult = calculator.querySelector('[data-calculator-shape]');
    const matchResult = calculator.querySelector('.pp-image-calculator__match');
    const recommendation = calculator.querySelector('[data-calculator-link]');
    const pixelsPerInch = 110;

    const categories = {
      square: {
        label: calculator.dataset.squareLabel,
        linkLabel: calculator.dataset.squareLinkLabel,
        href: '/collections/non-panoramic-products'
      },
      nonPanoramic: {
        label: calculator.dataset.nonPanoramicLabel,
        linkLabel: calculator.dataset.nonPanoramicLinkLabel,
        href: '/collections/non-panoramic-products'
      },
      panoramic: {
        label: calculator.dataset.panoramicLabel,
        linkLabel: calculator.dataset.panoramicLinkLabel,
        href: '/collections/panoramic-products'
      },
      ultraPanoramic: {
        label: calculator.dataset.ultraPanoramicLabel,
        linkLabel: calculator.dataset.ultraPanoramicLinkLabel,
        href: '/collections/ultra-panoramic-products'
      }
    };

    function updateCalculator() {
      const width = Math.max(0, Number.parseInt(widthInput.value, 10) || 0);
      const height = Math.max(0, Number.parseInt(heightInput.value, 10) || 0);

      widthResult.value = String(Math.round(width / pixelsPerInch));
      heightResult.value = String(Math.round(height / pixelsPerInch));

      if (!width || !height) {
        shapeResult.textContent = '';
        matchResult.hidden = true;
        recommendation.hidden = true;
        return;
      }

      const aspectRatio = Math.max(width, height) / Math.min(width, height);
      let category = categories.square;

      if (aspectRatio > 7 / 6) category = categories.nonPanoramic;
      if (aspectRatio > 13 / 6) category = categories.panoramic;
      if (aspectRatio > 3.8) category = categories.ultraPanoramic;

      shapeResult.textContent = category.label;
      matchResult.hidden = false;
      recommendation.textContent = category.linkLabel;
      recommendation.href = category.href;
      recommendation.hidden = false;
    }

    widthInput.addEventListener('input', updateCalculator);
    heightInput.addEventListener('input', updateCalculator);
    updateCalculator();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
if (!customElements.get('pp-cart-chat-guard')) {
  customElements.define('pp-cart-chat-guard', class extends HTMLElement {
    connectedCallback() {
      this.root = this.closest('.pp-cart-hybrid');
      const checkout = this.root?.querySelector('.cart-recap button[name="checkout"]');
      if (!checkout || !('IntersectionObserver' in window)) return;

      this.sticky = this.root.querySelector('.pp-cart-sticky');
      const stickyButton = this.sticky?.querySelector('button[name="checkout"]');
      if (this.sticky && stickyButton) {
        this.syncButton = () => {
          stickyButton.disabled = checkout.disabled;
          stickyButton.setAttribute('aria-disabled', String(checkout.disabled));
        };
        this.syncButton();
        this.buttonObserver = new MutationObserver(this.syncButton);
        this.buttonObserver.observe(checkout, { attributes: true, attributeFilter: ['disabled'] });
        this.root.setAttribute('data-pp-sticky-ready', '');
        if ('ResizeObserver' in window) {
          this.sizeObserver = new ResizeObserver(() => {
            const height = this.sticky.getBoundingClientRect().height;
            if (height > 0) document.documentElement.style.setProperty('--pp-cart-sticky-height', `${Math.ceil(height)}px`);
          });
          this.sizeObserver.observe(this.sticky);
        }
      }

      this.observer?.disconnect();
      this.observer = new IntersectionObserver((entries) => {
        if (!this.isConnected) return;
        this.root.toggleAttribute('data-pp-checkout-visible', entries.some(entry => entry.isIntersecting));
      }, { rootMargin: '24px 0px', threshold: 0 });
      this.observer.observe(checkout);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.sizeObserver?.disconnect();
      this.buttonObserver?.disconnect();
      this.root?.removeAttribute('data-pp-checkout-visible');
      this.root?.removeAttribute('data-pp-sticky-ready');
      document.documentElement.style.removeProperty('--pp-cart-sticky-height');
      this.observer = null;
      this.sizeObserver = null;
      this.buttonObserver = null;
      this.sticky = null;
      this.syncButton = null;
      this.root = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pp-canvas-size"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('pp-canvas-size')) {
 customElements.define('pp-canvas-size', class extends HTMLElement {
  connectedCallback() {
   this.controller?.abort(); this.controller = new AbortController();
   this.options = [...this.querySelectorAll('[data-size-option]')];
   if (!this.options.length) return;
   this.remembered = {};
   const initial = this.options.find(el => el.querySelector('input').checked) || this.options[0];
   this.remembered[initial.dataset.group] = initial;
   this.selectShape(initial.dataset.group);
   this.addEventListener('change', event => {
    if (event.target.matches('[data-shape]')) this.selectShape(event.target.value);
    if (event.target.matches('[data-size]')) this.selectSize(event.target.closest('[data-size-option]'));
   }, {signal:this.controller.signal});
   this.addEventListener('shopify:block:select', event => {
    const option=this.options.find(el=>el.dataset.blockId===event.detail.blockId);
    if(option){this.remembered[option.dataset.group]=option;this.selectShape(option.dataset.group);}
   }, {signal:this.controller.signal});
  }
  disconnectedCallback(){this.controller?.abort();}
  selectShape(group) {
   const available=this.options.filter(el=>el.dataset.group===group);
   if(!available.length)return;
   this.querySelectorAll('[data-shape]').forEach(input=>{
    input.checked=input.value===group;
    input.closest('label').hidden=!this.options.some(el=>el.dataset.group===input.value);
   });
   this.options.forEach(el=>{el.hidden=el.dataset.group!==group;el.querySelector('input').disabled=el.hidden;});
   this.selectSize(this.remembered[group]||available[Math.min(2,available.length-1)]);
  }
  selectSize(option) {
   if(!option)return;
   const d=option.dataset,w=Number(d.width),h=Number(d.height);
   if(!(w>0&&h>0))return;
   this.remembered[d.group]=option;
   this.options.forEach(el=>el.querySelector('input').checked=el===option);
   const width=(w/(Number(this.dataset.sofaWidth)||220)*(Number(this.dataset.sofaSpan)||60))+'%';
   this.querySelector('.cs__canvas').style.setProperty('--canvas-width',width);
   this.querySelector('.cs__canvas').style.setProperty('--canvas-ratio',w+' / '+h);
   this.querySelector('.cs__width').style.setProperty('--canvas-width',width);
   this.querySelector('[data-width-text]').textContent=this.dataset.widthLabel.replace('__WIDTH__',w);
   this.querySelector('[data-category-text]').textContent=d.category;
   this.querySelector('[data-title]').textContent=d.heading;
   this.querySelector('[data-description]').textContent=d.body;
   this.querySelectorAll('[data-product-link]').forEach(link=>link.hidden=link.dataset.productLink!==d.blockId);
  }
 });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pp-collection-editorial"]) return;
  try {
    
  if (!customElements.get('pp-collection-editorial')) {
    customElements.define('pp-collection-editorial', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        this.dataset.ready = 'true';
        const filters = this.querySelector('.pp-collection__filters');
        if (filters) {
          const available = new Set([...this.querySelectorAll('[data-category]')].map(card => card.dataset.category));
          filters.querySelectorAll('[data-filter]').forEach(button => {
            button.hidden = button.dataset.filter !== 'all' && !available.has(button.dataset.filter);
          });
          filters.hidden = available.size < 2;
          filters.addEventListener('click', event => {
            const button = event.target.closest('[data-filter]');
            if (!button) return;
            const cards = [...this.querySelectorAll('[data-category]')];
            cards.forEach(card => { card.hidden = button.dataset.filter !== 'all' && card.dataset.category !== button.dataset.filter; });
            filters.querySelectorAll('button').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
            const count = this.querySelector('[data-product-count]');
            const visibleCount = cards.filter(card => !card.hidden).length;
            count.textContent = (visibleCount === 1 ? this.dataset.singleProduct : count.dataset.countTemplate).replace('__COUNT__', visibleCount);
          });
        }
        const content = this.querySelector('.pp-collection__seo .metafield-rich_text_field');
        if (content && content.querySelector('h2') && content.querySelector('h3')) {
          const intro = document.createElement('div');
          intro.className = 'pp-collection__seo-intro';
          const topics = document.createElement('div');
          let group = intro;
          [...content.children].forEach(child => {
            if (child.tagName === 'H3') {
              group = document.createElement('section');
              group.className = 'pp-collection__seo-topic';
              topics.append(group);
            }
            group.append(child);
          });
          content.classList.add('pp-collection__seo-layout');
          content.append(intro, topics);
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pp-faq-page"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pp-faq-page')) {
    customElements.define('pp-faq-page', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = {signal:this.controller.signal};
        this.search = this.querySelector('[data-faq-search]');
        this.questions = [...this.querySelectorAll('[data-faq-question]')];
        this.groups = [...this.querySelectorAll('[data-faq-group]')];
        this.beforeSearch = null;
        this.index = new Map(this.questions.map(q => [q,this.words(q.textContent+' '+q.dataset.faqKeywords).join(' ')]));
        this.querySelectorAll('[data-faq-enhanced]').forEach(el => el.hidden = false);
        this.querySelectorAll('[data-faq-topic-link]').forEach(link => {
          const group = this.groups.find(group => group.dataset.faqTopic === link.dataset.faqTopicLink);
          const count = group?.querySelectorAll('[data-faq-question]').length || 0;
          link.querySelector('[data-faq-topic-count]').textContent = String(count).padStart(2,'0');
          link.hidden = count === 0;
        });
        this.querySelectorAll('[data-faq-jump]').forEach(link => {
          if (link.closest('.pp-faq__popular')) link.hidden = !this.findTarget(link.hash);
        });
        this.search.addEventListener('input', () => this.filter(true), options);
        this.addEventListener('click', event => {
          const reset = event.target.closest('[data-faq-clear],[data-faq-reset]');
          if (reset) { this.clear(); this.search.focus(); return; }
          const link = event.target.closest('[data-faq-jump]');
          if (!link) return;
          const target = this.findTarget(link.hash);
          if (!target) return;
          event.preventDefault();
          this.clear();
          this.reveal(target,true);
          if (!window.Shopify?.designMode) history.replaceState(null,'',link.hash);
        },options);
        window.addEventListener('hashchange', () => this.followHash(),options);
        document.addEventListener('shopify:block:select', event => {
          if (!this.contains(event.target)) return;
          this.clear();
          const target = event.target.closest('[data-faq-question],[data-faq-group]') || event.target;
          this.reveal(target,true);
        },options);
        this.filter(false);
        this.followHash();
      }
      disconnectedCallback() { this.controller?.abort(); }
      words(value) {
        const synonyms = {shipping:'delivery',images:'photo',image:'photo',photos:'photo',colors:'colours',color:'colour',refunds:'refund'};
        return value.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/[’']/g,'').split(/[^a-z0-9]+/).filter(Boolean).map(word => synonyms[word] || word);
      }
      filter(expand) {
        const terms = this.words(this.search.value);
        if (terms.length && expand && !this.beforeSearch) this.beforeSearch = new Set(this.questions.filter(q=>q.open));
        if (!terms.length && this.beforeSearch) { this.questions.forEach(q => q.open=this.beforeSearch.has(q)); this.beforeSearch=null; }
        let count=0;
        this.questions.forEach(q => { const hit=terms.every(term=>this.index.get(q).includes(term));q.hidden=!hit;if(hit)count++;if(hit&&terms.length&&expand)q.open=true; });
        this.groups.forEach(group => group.hidden=![...group.querySelectorAll('[data-faq-question]')].some(q=>!q.hidden));
        this.querySelector('[data-faq-status]').textContent=(terms.length?this.dataset.resultsLabel:this.dataset.allLabel).replace('__COUNT__',String(count)).replace('__QUERY__',this.search.value);
        this.querySelector('[data-faq-clear]').hidden=!this.search.value;
        this.querySelector('[data-faq-empty]').hidden=count>0;
      }
      clear() { this.search.value='';this.filter(false); }
      findTarget(hash) { if(!hash||hash.charAt(0)!=='#')return null;let id;try{id=decodeURIComponent(hash.slice(1))}catch{return null}return [...this.querySelectorAll('[id]')].find(el=>el.id===id)||null; }
      reveal(target,scroll) { if(target.matches('details'))target.open=true;if(scroll){target.scrollIntoView({block:'start',behavior:'auto'});if(target.matches('details'))target.querySelector('summary').focus({preventScroll:true});} }
      followHash() { const target=this.findTarget(location.hash);if(target){this.clear();this.reveal(target,true);} }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pp-floating-collection"]) return;
  try {
    
  if (!customElements.get('pp-collection-editorial')) {
    customElements.define('pp-collection-editorial', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        this.dataset.ready = 'true';
        const filters = this.querySelector('.pp-collection__filters');
        if (filters) {
          const available = new Set([...this.querySelectorAll('[data-category]')].map(card => card.dataset.category));
          filters.querySelectorAll('[data-filter]').forEach(button => {
            button.hidden = button.dataset.filter !== 'all' && !available.has(button.dataset.filter);
          });
          filters.hidden = available.size < 2;
          filters.addEventListener('click', event => {
            const button = event.target.closest('[data-filter]');
            if (!button) return;
            const cards = [...this.querySelectorAll('[data-category]')];
            cards.forEach(card => { card.hidden = button.dataset.filter !== 'all' && card.dataset.category !== button.dataset.filter; });
            filters.querySelectorAll('button').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
            const count = this.querySelector('[data-product-count]');
            const visibleCount = cards.filter(card => !card.hidden).length;
            count.textContent = (visibleCount === 1 ? this.dataset.singleProduct : count.dataset.countTemplate).replace('__COUNT__', visibleCount);
          });
        }
        const content = this.querySelector('.pp-collection__seo .metafield-rich_text_field');
        if (content && content.querySelector('h2') && content.querySelector('h3')) {
          const intro = document.createElement('div');
          intro.className = 'pp-collection__seo-intro';
          const topics = document.createElement('div');
          let group = intro;
          [...content.children].forEach(child => {
            if (child.tagName === 'H3') {
              group = document.createElement('section');
              group.className = 'pp-collection__seo-topic';
              topics.append(group);
            }
            group.append(child);
          });
          content.classList.add('pp-collection__seo-layout');
          content.append(intro, topics);
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pp-frame-comparison"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pp-frame-comparison')) {
  customElements.define('pp-frame-comparison', class extends HTMLElement {
    connectedCallback() {
      this.abortController?.abort();
      this.abortController = new AbortController();
      const signal = this.abortController.signal;
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-colour]');
        if (button && this.contains(button)) this.selectColour(button);
        const trigger = event.target.closest('[data-frame-dialog]');
        if (trigger && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey && event.button === 0) {
          const dialog = this.querySelector('#' + CSS.escape(trigger.dataset.frameDialog));
          if (dialog && typeof dialog.showModal === 'function') {
            event.preventDefault();
            dialog.returnFocus = trigger;
            dialog.showModal();
            dialog.scrollTop = 0;
          }
        }
        const close = event.target.closest('[data-frame-dialog-close]');
        if (close) close.closest('dialog').close();
        if (event.target instanceof HTMLDialogElement) {
          const rect = event.target.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.target.close();
        }
      }, { signal });
      this.querySelectorAll('dialog').forEach(dialog => {
        dialog.addEventListener('keydown', event => {
          if (event.key !== 'Tab') return;
          const controls = Array.from(dialog.querySelectorAll('a[href], button:not([disabled])')).filter(element => element.getClientRects().length);
          const first = controls[0];
          const last = controls[controls.length - 1];
          if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
          } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
          }
        }, { signal });
        dialog.addEventListener('close', () => {
          if (dialog.returnFocus?.isConnected) dialog.returnFocus.focus({ preventScroll: true });
        }, { signal });
      });
      this.addEventListener('shopify:block:select', event => {
        const button = event.target.closest('[data-colour]');
        if (button) this.selectColour(button);
        const details = event.target.closest('details');
        if (details) details.open = true;
      }, { signal });
    }
    disconnectedCallback() {
      this.abortController?.abort();
      this.querySelectorAll('dialog[open]').forEach(dialog => dialog.close());
    }
    selectColour(button) {
      this.style.setProperty('--compare-frame', button.dataset.colourValue);
      this.style.setProperty('--compare-frame-edge', button.dataset.edge);
      this.querySelectorAll('[data-colour]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      this.querySelector('[data-colour-label]').textContent = button.dataset.colour;
      this.querySelector('[data-comparison-status]').textContent = this.dataset.announcement.replace('__COLOUR__', button.dataset.colour);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pp-hangtiles-layouts"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pp-hangtiles-layouts')) {
  customElements.define('pp-hangtiles-layouts', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) this.controller.abort();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.data = JSON.parse(this.querySelector('[data-hangtiles-data]').textContent);
      this.addEventListener('change', () => this.update(), {signal});
      this.querySelector('[data-continue]').addEventListener('click', event => {
        if (event.currentTarget.getAttribute('aria-disabled') === 'true') event.preventDefault();
      }, {signal});
      this.addEventListener('shopify:block:select', event => {
        const blockId = event.detail.blockId;
        const input = Array.from(this.querySelectorAll('[data-layout]')).find(el => el.value === blockId);
        if (input) {input.checked = true; this.update();}
        const photo = Array.from(this.querySelectorAll('[data-photo-id]')).find(el => el.dataset.photoId === blockId);
        if (photo && photo.hidden) {
          const largest = Array.from(this.querySelectorAll('[data-layout]')).sort((a,b)=>Number(b.dataset.count)-Number(a.dataset.count))[0];
          if (largest) {largest.checked = true; this.update();}
        }
      }, {signal});
      this.update();
      this.dataset.ready = 'true';
    }
    disconnectedCallback() {this.controller?.abort(); this.controller = null;}
    text(key, values) {return this.data.labels[key].replace(/\[(\w+)\]/g, (match,k)=>values[k] ?? match);}
    update() {
      const layout = this.querySelector('[data-layout]:checked');
      const colour = this.querySelector('[data-frame-choice]:checked').value;
      if (!layout) return;
      const count = Number(layout.dataset.count), columns = Number(layout.dataset.columns), rows = Math.ceil(count / columns);
      const tile = Number(this.dataset.tileSize), gap = Number(this.dataset.gap);
      const width = columns * tile + (columns - 1) * gap, height = rows * tile + (rows - 1) * gap;
      const gallery = this.querySelector('.ht-gallery'), grid = this.querySelector('.ht-photo-grid');
      gallery.style.width = `${width / Number(this.dataset.wallWidth) * 100}%`;
      gallery.style.setProperty('--cols', columns);
      grid.style.columnGap = `${gap / width * 100}%`; grid.style.rowGap = `${gap / height * 100}%`;
      grid.style.aspectRatio = `${width} / ${height}`;
      const originalTiles = Array.from(grid.querySelectorAll('[data-photo-id]'));
      grid.querySelectorAll('[data-clone]').forEach(el => el.remove());
      originalTiles.forEach((el, i) => {el.hidden = i >= count;});
      if (originalTiles.length) for (let i=originalTiles.length; i<count; i++) {
        const clone=originalTiles[i % originalTiles.length].cloneNode(true);
        clone.removeAttribute('data-photo-id'); clone.removeAttribute('data-shopify-editor-block'); clone.dataset.clone='true'; clone.hidden=false; grid.append(clone);
      }
      this.querySelector('.ht-room').dataset.frame = colour;
      const colourLabel = this.data.labels[colour];
      gallery.setAttribute('aria-label', this.text('description', {count, colour:colourLabel, columns, rows}));
      this.querySelector('[data-room-title]').textContent = layout.dataset.title;
      this.querySelector('[data-width]').textContent = `${width} cm`;
      this.querySelector('[data-footprint]').textContent = this.text('footprint', {width,height});
      this.querySelector('[data-set-description]').textContent = this.text('selection', {count, colour:colourLabel});
      const variant=this.data.products[colour].find(v=>v.count===count);
      const available=Boolean(variant?.available), link=this.querySelector('[data-continue]');
      this.querySelector('[data-price]').textContent=available ? variant.price : '';
      this.querySelector('[data-unit-price]').textContent=variant ? this.text('perTile', {price:variant.unitPrice}) : '';
      this.querySelector('[data-cta-label]').textContent=available ? this.data.labels.cta : this.data.labels.unavailable;
      if(available){link.href=variant.url;link.removeAttribute('aria-disabled');}else{link.removeAttribute('href');link.setAttribute('aria-disabled','true');}
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pp-menu-preview"]) return;
  try {
    
(() => {
  function init() {
    const root = document.getElementById('pp-navigation-preview');
    if (!root || root.dataset.bound) return;
    root.dataset.bound = 'true';
    const header = root.querySelector('.ppnav-header');
    function measureHeader() {
      if (!root.isConnected) return;
      const headerHeight = header.getBoundingClientRect().height.toFixed(2) + 'px';
      const toolbarHeight = '0px';
      document.documentElement.style.setProperty('--ppnav-header-height', headerHeight);
      document.documentElement.style.setProperty('--ppnav-toolbar-height', toolbarHeight);
      document.documentElement.style.setProperty('--header-height', headerHeight);
    }
    const headerResize = new ResizeObserver(measureHeader);
    headerResize.observe(header);
    measureHeader();
    root.classList.toggle('ppnav-scrolled', window.scrollY > 10);
    const scrollTracker = document.getElementById('header-scroll-tracker');
    const scrollObserver = scrollTracker ? new IntersectionObserver(entries => {
      root.classList.toggle('ppnav-scrolled', !entries[0].isIntersecting);
    }) : null;
    if (scrollObserver) scrollObserver.observe(scrollTracker);
    document.addEventListener('shopify:section:unload', function cleanup(event) {
      if (!event.target.contains(root)) return;
      headerResize.disconnect();
      if (scrollObserver) scrollObserver.disconnect();
      document.removeEventListener('shopify:section:unload', cleanup);
    });

    const menus = Array.from(root.querySelectorAll('.ppnav-dropdown'));
    const mobile = root.querySelector('#ppnav-mobile');
    const search = root.querySelector('#ppnav-search');
    const mobileNav = mobile.querySelector('nav');
    const mobileSearchToggle = mobile.querySelector('[data-ppnav-mobile-search-toggle]');
    const mobileSearchForm = mobile.querySelector('#ppnav-mobile-search-form');
    const mobileSearchInput = mobileSearchForm.querySelector('input[type="search"]');
    let mobileScrollFrame;
    function setMobileSearch(open, restoreFocus = false) {
      mobileSearchForm.hidden = !open;
      mobileSearchToggle.setAttribute('aria-expanded', String(open));
      if (open) mobileSearchInput.focus({ preventScroll: true });
      else if (restoreFocus) mobileSearchToggle.focus({ preventScroll: true });
    }
    mobileSearchToggle.addEventListener('click', () => setMobileSearch(mobileSearchForm.hidden));
    mobile.addEventListener('keydown', event => {
      if (event.key === 'Escape' && !mobileSearchForm.hidden) {
        event.preventDefault();
        event.stopPropagation();
        setMobileSearch(false, true);
      }
    });
    mobile.addEventListener('close', () => {
      setMobileSearch(false);
      cancelAnimationFrame(mobileScrollFrame);
    });
    mobileNav.querySelectorAll('.ppnav-mobile-details').forEach(detail => {
      detail.addEventListener('toggle', () => {
        if (!detail.open || !mobile.open) return;
        Array.from(detail.parentElement.children).forEach(sibling => {
          if (sibling !== detail && sibling.matches('details.ppnav-mobile-details')) sibling.open = false;
        });
        cancelAnimationFrame(mobileScrollFrame);
        mobileScrollFrame = requestAnimationFrame(() => {
          mobileScrollFrame = requestAnimationFrame(() => {
            if (!detail.open || !mobile.open) return;
            const heading = detail.querySelector('summary');
            const top = mobileNav.scrollTop + heading.getBoundingClientRect().top - mobileNav.getBoundingClientRect().top;
            mobileNav.scrollTo({ top: Math.max(0, top), behavior: 'instant' });
          });
        });
      });
    });
    let mask;
    let lastTrigger;
    let hoverTimer;
    function closeMenus(except) {
      menus.forEach(menu => { if (menu !== except) menu.open = false; });
      if (!menus.some(menu => menu.open) && mask) { mask.remove(); mask = null; }
    }
    function syncMask() {
      if (menus.some(menu => menu.open)) {
        if (!mask) {
          mask = document.createElement('button');
          mask.className = 'ppnav-mask';
          mask.setAttribute('aria-label', root.dataset.closeLabel);
          mask.addEventListener('click', () => closeMenus());
          document.body.appendChild(mask);
        }
      } else if (mask) { mask.remove(); mask = null; }
    }
    menus.forEach(menu => {
      menu.addEventListener('toggle', () => {
        const summary = menu.querySelector('summary');
        summary.setAttribute('aria-expanded', String(menu.open));
        if (menu.open) closeMenus(menu);
        syncMask();
      });
      menu.addEventListener('pointerenter', event => {
        if (event.pointerType !== 'mouse' || !matchMedia('(hover:hover) and (min-width:900px)').matches) return;
        clearTimeout(hoverTimer);
        hoverTimer = setTimeout(() => { closeMenus(menu); menu.open = true; }, 220);
      });
      menu.addEventListener('pointerleave', () => {
        clearTimeout(hoverTimer);
      });
      menu.addEventListener('focusout', () => {
        setTimeout(() => { if (!menu.contains(document.activeElement)) { menu.open = false; syncMask(); } }, 0);
      });
    });
    root.addEventListener('pointerleave', () => {
      clearTimeout(hoverTimer);
      hoverTimer = setTimeout(() => {
        if (!menus.some(menu => menu.contains(document.activeElement))) closeMenus();
      }, 220);
    });
    root.addEventListener('keydown', event => {
      if (event.key === 'Escape' && menus.some(menu => menu.open)) {
        const current = menus.find(menu => menu.open);
        closeMenus();
        current.querySelector('summary').focus();
      }
    });
    root.addEventListener('click', event => {
      const link = event.target.closest('a[href]');
      if (!link) return;
      const destination = new URL(link.href, location.href);
      if (destination.origin !== location.origin || destination.pathname !== location.pathname || destination.hash !== '#compare-canvas-sizes') return;
      clearTimeout(hoverTimer);
      closeMenus();
      if (mobile.open) mobile.close();
    });
    document.addEventListener('click', event => {
      if (!root.contains(event.target)) closeMenus();
    });
    function openDialog(dialog, trigger) {
      clearTimeout(hoverTimer);
      closeMenus();
      [mobile, search].forEach(other => { if (other.open) other.close(); });
      lastTrigger = trigger;
      dialog.showModal();
      if (dialog === search) search.querySelector('input[type="search"]').focus();
    }
    root.querySelectorAll('[data-ppnav-mobile]').forEach(button => button.addEventListener('click', () => openDialog(mobile, button)));
    root.querySelectorAll('[data-ppnav-search]').forEach(button => button.addEventListener('click', () => openDialog(search, button)));
    root.querySelectorAll('[data-ppnav-close]').forEach(button => button.addEventListener('click', () => button.closest('dialog').close()));
    [mobile, search].forEach(dialog => {
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const r = dialog.getBoundingClientRect();
        if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close();
      });
      dialog.addEventListener('close', () => {
        if (![mobile, search].some(other => other.open) && lastTrigger?.isConnected) {
          if (lastTrigger.closest('dialog') && !lastTrigger.closest('dialog').open) {
            root.querySelector('.ppnav-mobile-trigger').focus();
          } else lastTrigger.focus({ preventScroll: true });
        }
      });
    });
    matchMedia('(max-width:899px)').addEventListener('change', event => {
      clearTimeout(hoverTimer);
      closeMenus();
      if (!event.matches && mobile.open) {
        lastTrigger = root.querySelector('.ppnav-logo');
        mobile.close();
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pp-premium-closing"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pp-premium-closing')) {
  customElements.define('pp-premium-closing', class extends HTMLElement {
    connectedCallback() {
      this.events = new AbortController();
      this.button = this.querySelector('.mobile-cta');
      const update = () => {
        const hero = document.querySelector('.pp-premium .hero');
        const finishes = document.querySelector('.pp-premium .finishes');
        const final = this.querySelector('.final-cta');
        if (!hero || !finishes || !final) {this.button.hidden = true; return;}
        const f = finishes.getBoundingClientRect();
        this.button.hidden = innerWidth > 680 || hero.getBoundingClientRect().bottom > 0 || (f.top < innerHeight && f.bottom > 0) || final.getBoundingClientRect().top < innerHeight;
      };
      this.observer = new IntersectionObserver(update);
      document.querySelectorAll('.pp-premium .hero, .pp-premium .finishes, .pp-premium .final-cta').forEach(e => this.observer.observe(e));
      window.addEventListener('resize', update, {passive:true,signal:this.events.signal});
      update();
    }
    disconnectedCallback() {this.observer?.disconnect();this.events?.abort();}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pp-premium-finishes"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pp-premium-finishes')) {
  customElements.define('pp-premium-finishes', class extends HTMLElement {
    connectedCallback() {
      this.events = new AbortController();
      this.addEventListener('click', event => {
        const trigger = event.target.closest('[data-premium-open]');
        if (trigger && !event.metaKey && !event.ctrlKey && !event.shiftKey && event.button === 0) {
          const dialog = this.querySelector('#' + CSS.escape(trigger.dataset.premiumOpen));
          if (dialog && typeof dialog.showModal === 'function') {
            event.preventDefault(); this.returnFocus = trigger; dialog.showModal();
          }
        }
        if (event.target.closest('.dialog-close')) event.target.closest('dialog').close();
        if (event.target instanceof HTMLDialogElement) {
          const r = event.target.getBoundingClientRect();
          if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) event.target.close();
        }
      }, {signal:this.events.signal});
      this.querySelectorAll('dialog').forEach(dialog => dialog.addEventListener('close', () => this.returnFocus?.focus({preventScroll:true}), {signal:this.events.signal}));
    }
    disconnectedCallback() { this.querySelectorAll('dialog[open]').forEach(d => d.close()); this.events?.abort(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pp-premium-studio"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pp-premium-studio')) {
  customElements.define('pp-premium-studio', class extends HTMLElement {
    connectedCallback() {
      this.events = new AbortController();
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-stage]');
        if (!button) return;
        this.querySelectorAll('[data-stage]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
        this.querySelectorAll('[data-scene]').forEach(s => s.hidden = s.dataset.scene !== button.dataset.stage);
      }, {signal:this.events.signal});
    }
    disconnectedCallback() {this.events?.abort();}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pp-start-here-guide"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function initialiseGuide(scope) {
      scope.querySelectorAll('[data-guide-calculator]').forEach((form) => {
        if (form.dataset.ready) return;
        form.dataset.ready = 'true';
        const width = form.elements.width;
        const height = form.elements.height;
        const result = form.querySelector('[data-guide-result]');
        const error = form.querySelector('[data-guide-error]');
        const links = form.querySelectorAll('[data-guide-match]');
        function clearResult() { result.hidden = true; error.hidden = true; width.removeAttribute('aria-invalid'); height.removeAttribute('aria-invalid'); }
        width.addEventListener('input', clearResult);
        height.addEventListener('input', clearResult);
        form.addEventListener('submit', (event) => {
          event.preventDefault();
          const w = Number(width.value), h = Number(height.value);
          const validWidth = Number.isSafeInteger(w) && w > 0;
          const validHeight = Number.isSafeInteger(h) && h > 0;
          if (!validWidth || !validHeight) {
            result.hidden = true; error.hidden = false;
            width.setAttribute('aria-invalid', String(!validWidth)); height.setAttribute('aria-invalid', String(!validHeight));
            (!validWidth ? width : height).focus(); return;
          }
          error.hidden = true;
          const inchesWidth = Math.round(w / 110), inchesHeight = Math.round(h / 110);
          form.querySelector('[data-guide-inches]').textContent = inchesWidth + ' × ' + inchesHeight;
          form.querySelector('[data-guide-cm]').textContent = Math.round(inchesWidth * 2.54) + ' × ' + Math.round(inchesHeight * 2.54);
          const ratio = Math.max(w,h) / Math.min(w,h);
          let shape = 'square';
          if (ratio > 7 / 6) shape = 'standard';
          if (ratio > 13 / 6) shape = 'panoramic';
          if (ratio > 3.8) shape = 'ultra';
          links.forEach((link) => { link.hidden = link.dataset.guideMatch !== shape; });
          result.hidden = false;
        });
      });
    }
    initialiseGuide(document);
    document.addEventListener('shopify:section:load', (event) => initialiseGuide(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pp-studio-crop"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('pp-studio-crop')){
 customElements.define('pp-studio-crop',class extends HTMLElement{
  connectedCallback(){
   if(this.abort)return;this.abort=new AbortController();const o={signal:this.abort.signal};
   this.buttons=[...this.querySelectorAll('[data-crop]')];this.active=this.buttons[0];
   this.addEventListener('click',e=>{const b=e.target.closest('[data-crop]');if(b){this.active=b;this.render();}},o);
   this.querySelector('.crop-image img')?.addEventListener('load',()=>this.render(),o);
   document.addEventListener('shopify:block:select',e=>{const b=this.buttons.find(el=>el.dataset.block===e.detail.blockId);if(b){this.active=b;this.render();}},o);
   this.render();
  }
  disconnectedCallback(){this.abort?.abort();this.abort=null;}
  render(){
   if(!this.active)return;
   const img=this.querySelector('.crop-image img');if(!img)return;
   const source=(img.naturalWidth||Number(img.getAttribute('width')))/(img.naturalHeight||Number(img.getAttribute('height')));
   const shape=this.active.dataset.crop;
   const ratio={panoramic:3,landscape:1.5,square:1,portrait:2/3}[shape]||source;
   const w=Math.min(100,100*ratio/source),h=Math.min(100,100*source/ratio);
   const box=this.querySelector('.crop-window');Object.assign(box.style,{left:`${(100-w)/2}%`,top:`${(100-h)/2}%`,bottom:'auto',width:`${w}%`,height:`${h}%`});
   this.buttons.forEach(b=>{b.classList.toggle('selected',b===this.active);b.setAttribute('aria-pressed',String(b===this.active));});
   this.querySelectorAll('[data-explanation]').forEach(p=>p.hidden=p.dataset.explanation!==this.active.dataset.block);
  }
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pp-studio-walkthrough"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pp-studio-walkthrough')) {
 customElements.define('pp-studio-walkthrough', class extends HTMLElement {
  connectedCallback() {
   if (this.abort) return;
   this.abort = new AbortController();
   const options = {signal:this.abort.signal};
   this.steps = [...this.querySelectorAll('[data-step]')];
   this.current = 0;
   this.device = matchMedia('(max-width:760px)').matches ? 'mobile' : 'desktop';
   this.addEventListener('click', e => {
    const summary = e.target.closest('.step summary');
    if (summary) {e.preventDefault();this.select(Number(summary.parentElement.dataset.step));return;}
    const tab=e.target.closest('[data-guide-step]');
    if(tab)this.select(Number(tab.dataset.guideStep));
    const device=e.target.closest('[data-device]');
    if(device){this.device=device.dataset.device;this.render();}
    if(e.target.closest('[data-next]'))this.select(this.current+1);
    if(e.target.closest('[data-previous]'))this.select(this.current-1);
   },options);
   document.addEventListener('shopify:block:select',e=>{const i=this.steps.findIndex(el=>el.dataset.block===e.detail.blockId);if(i>=0)this.select(i);},options);
   this.classList.add('guide-ready');this.render();
  }
  disconnectedCallback(){this.abort?.abort();this.abort=null;}
  select(i){this.current=Math.max(0,Math.min(this.steps.length-1,i));this.render();}
  render(){
   this.dataset.deviceView=this.device;
   this.steps.forEach((el,i)=>el.open=i===this.current);
   this.querySelectorAll('[data-scene]').forEach(el=>el.hidden=Number(el.dataset.scene)!==this.current);
   this.querySelector('[data-number]').textContent=`${this.current+1} / ${this.steps.length}`;
   this.querySelector('[data-caption]').textContent=this.querySelector(`[data-caption-source="${this.current}"]`)?.content.textContent||'';
   this.querySelector('[data-previous]').disabled=this.current===0;
   this.querySelector('[data-next]').disabled=this.current>=this.steps.length-1;
   this.querySelectorAll('[data-guide-step]').forEach(el=>el.setAttribute('aria-pressed',String(Number(el.dataset.guideStep)===this.current)));
   this.querySelectorAll('[data-device]').forEach(el=>{const active=el.dataset.device===this.device;el.classList.toggle('selected',active);el.setAttribute('aria-pressed',String(active));});
  }
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pp-wedding-choices"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pp-wedding-extra-choices')) {
    class WeddingExtraChoices extends HTMLElement {
      connectedCallback() {
        this.toggleButton = this.querySelector('[data-group-toggle]');
        this.panel = this.querySelector('[data-group-panel]');
        this.staticTitle = this.querySelector('[data-static-title]');
        if (!this.toggleButton || !this.panel || !this.staticTitle) return;
        this.mobileExpanded = false;
        this.mediaQuery = window.matchMedia('(max-width: 699px)');
        this.syncLayout = () => {
          const mobile = this.mediaQuery.matches;
          this.toggleButton.hidden = !mobile;
          this.staticTitle.hidden = mobile;
          this.panel.hidden = mobile && !this.mobileExpanded;
          this.toggleButton.setAttribute('aria-expanded', String(!this.panel.hidden));
        };
        this.toggleGroup = () => {
          this.mobileExpanded = !this.mobileExpanded;
          this.syncLayout();
        };
        this.revealBlock = () => {
          this.mobileExpanded = true;
          this.syncLayout();
        };
        this.toggleButton.addEventListener('click', this.toggleGroup);
        this.mediaQuery.addEventListener('change', this.syncLayout);
        this.addEventListener('shopify:block:select', this.revealBlock);
        this.syncLayout();
      }
      disconnectedCallback() {
        this.toggleButton?.removeEventListener('click', this.toggleGroup);
        this.mediaQuery?.removeEventListener('change', this.syncLayout);
        this.removeEventListener('shopify:block:select', this.revealBlock);
      }
    }
    customElements.define('pp-wedding-extra-choices', WeddingExtraChoices);
  }

  } catch(e) { console.error(e); }
})();
})();
